
    import I18n from 'i18nObj';
    
      import 'translations/quiz_engine_modal';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('quiz_engine_modal');
  